export const HOUR_IN_MS = 60 * 60 * 1000;
